/**
*
* Label
*
*/

import React from 'react';


import Hint from 'components/Hint';

import LabelWrapper from './styles/LabelWrapper';
import LabelRequireContent from './styles/LabelRequireContent';

type LabelProps = {
  title: string,
  thisStyles?: Object,
  properties?: boolean,
  innerRef?: React.RefObject<HTMLElement>,
  onClick?: () => void,
  hint?: {
    title: string,
    body: string,
  },
  labelStylesCss?: undefined | string ,
  required?: boolean,
}


function Label(props: LabelProps) {
  return (
    <LabelWrapper ref={props.innerRef} properties={props.properties} onClick={props.onClick} thisStyles={props.thisStyles} hint={props.hint ? true : false} labelStylesCss={props.labelStylesCss}>
      {props.title}
      {props.required ? <LabelRequireContent>*</LabelRequireContent> : ''}
      { props.hint ? (<Hint message={props.hint} />) : ''}
    </LabelWrapper>
  );
}


export default Label;
